export default "__VITE_ASSET__EBUVkroI__"